export default [
  {
    path: '/thirdGoods/handleGoods',
    name: 'handleGoods',
    meta: {
      title: '待处理商品',
    },
    component(resolve) {
      require(['COMPONENTS/thirdGoods/handleGoods/main.vue'], resolve)
    }
  },
  {
    path: '/thirdGoods/taobaoShopManager',
    name: 'taobaoShopManager',
    meta: {
      title: '淘宝店铺管理',
    },
    component(resolve) {
      require(['COMPONENTS/thirdGoods/taobaoShopManager/main.vue'], resolve)
    }
  }
]